/* Imports */
import React from "react"
import styled from "styled-components"
import { Wrapper, Main, Font, Variables } from "fajny-react"

import BaseLayout from "../../components/BaseLayout"

const StyledMain = styled(Main)`
    background-color: ${Variables.Colors.Danger100};
`

const DemoMainForm = () => {
    return (
        <BaseLayout title="Demo Main form">
            <Wrapper>
                <StyledMain size="form">
                    <Font.H1>Main</Font.H1>
                </StyledMain>
            </Wrapper>
        </BaseLayout>
    )
}

export default DemoMainForm
